import { render, staticRenderFns } from "./InsuranceBridgeRecipeAddressSelector.vue?vue&type=template&id=55609ec7&"
import script from "./InsuranceBridgeRecipeAddressSelector.vue?vue&type=script&lang=js&"
export * from "./InsuranceBridgeRecipeAddressSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports